import { createContext, useContext } from 'react';

export const FieldContext = createContext();

export function useField() {
  return useContext(FieldContext);
}
